module.exports = __webpack_public_path__ + "img/sphone_attendpage.537db0d7.png";